import React, {Component, Fragment} from 'react';
import AxiosHelper from '../helpers/axiosHelper';
import {NotificationContainer} from 'react-notifications';
import ShiftDetailsDialogContainer from '../containers/dialogs/ShiftDetailsDialogContainer';
import {
    HashRouter as Router
} from 'react-router-dom';

import '../lib/bootstrap/css/bootstrap.min.css';
import '../lib/font-awesome/scss/font-awesome.css';
import 'react-select2-wrapper/css/select2.css';
import '../lib/awesome-bootstrap-checkbox/awesome-bootstrap-checkbox.css';
import '../lib/react-datepicker/react-datepicker.css';
import 'react-notifications/lib/notifications.css';
import '../lib/inspinia/SCSS/style.scss';
import '../css/App.scss';
import 'react-datepicker/dist/react-datepicker.css';
import "react-awesome-popover/dest/react-awesome-popover.css";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import Mousetrap from 'mousetrap';

import MainPageContainer from '../containers/pages/MainPageContainer';
import LoginPage from '../components/pages/LoginPage';
import AddShiftDialog from "./dialogs/AddShiftDialog";
import ScopeSmall from "./data/ScopeSmall";
import ScopeFull from "./data/ScopeFull";

class App extends Component {
    constructor(props) {
        super(props);

        this.handleLogoutByShortcut = this.handleLogoutByShortcut.bind(this);
    }

    componentWillMount() {
        AxiosHelper.init();
    }

    componentDidMount() {
        Mousetrap.bind(['ctrl+l'], this.handleLogoutByShortcut);
    }

    handleLogoutByShortcut() {
        this.props.logout();
    }

    render() {
        return (
            <div className="App">
                <ScopeSmall/>
                {this.props.authorized ? (
                    <Fragment>
                        <ScopeFull/>
                        <MainPageContainer/>
                    </Fragment>
                ) : (
                    <LoginPage/>
                )}
                {(this.props.authorized && (this.props.translationAddEditDialog.open || this.props.addShiftDialogOpen || this.props.addLocationDialogOpen || this.props.app.dialogShiftDetailsOpen)) ? (
                    <div className="modal-backdrop in"/>
                ) : null}
                {(this.props.authorized && this.props.app.dialogShiftDetailsOpen ? (
                    <Router>
                        <ShiftDetailsDialogContainer/>
                    </Router>
                ) : null )}
                {(this.props.authorized && this.props.app.dialogAddShiftOpen ? (
                    <Router>
                        <AddShiftDialog/>
                    </Router>
                ) : null )}
                <NotificationContainer/>
            </div>
        );
    }
}

export default App;
